import { Box, Chip } from '@mui/material';
import { useMemo } from 'react';

interface IFormChipListProps<T> {
  options: T[];
  selectedIds: (number | string)[]; 
  valueField: keyof T;
  labelField: keyof T;
  onRemove: (id: number | string) => void;
}

export const FormChipList = <T,>({
  options,
  selectedIds,
  valueField,
  labelField,
  onRemove,
}: IFormChipListProps<T>) => {
  const chipsToRender = useMemo(() => {
    if (!selectedIds?.length || !options?.length) return [];

    return options.filter((opt) => {
      const itemValue = opt[valueField] as unknown as number | string;
      return selectedIds.includes(itemValue);
    });
  }, [options, selectedIds, valueField]);

  if (chipsToRender.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        mt: '-16px',
        mb: 2.5,
        position: 'relative',
        zIndex: 1,
      }}
    >
      {chipsToRender.map((opt) => {
        const id = opt[valueField] as string | number;
        const label = opt[labelField] as string;

        return (
          <Chip
            key={id}
            label={label}
            color="primary"
            variant="outlined"
            onDelete={() => onRemove(id)}
          />
        );
      })}
    </Box>
  );
};